import React, { useState, useEffect } from 'react'
import { graphql } from "gatsby"
import { GatsbyImage, IGatsbyImageData, getImage } from "gatsby-plugin-image"
import * as styles from "./VideoCard.css"
import ReactPlayer from 'react-player/lazy'
import {
  Card,
} from "../ui"

export type VideoCardProps = {
  id: string
  title: string
  url: string
  poster: {
    id: string
    title: string
    gatsbyImageData: any
  }
}

export default function VideoCard(props: VideoCardProps) {
  const [hasWindow, setHasWindow] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHasWindow(true);
    }
  }, [])

  const poster = props.poster ? 
    <GatsbyImage
      alt={props.poster.title}
      image={getImage(props.poster)}
    /> : null
  return (
    <Card>
      <div className={styles.videoContainer}>
        {hasWindow && (
          <ReactPlayer
            playing={poster ? true : false}
            light={poster}
            controls={true}
            className={styles.videoPlayer}
            url={props.url}
            width="100%"
            height="100%"
          />
        )}
      </div>
    </Card>
  )
}

export const query = graphql`
  fragment VideoCardContent on VideoCard {
    id
    desktopRight
    title
    url
    poster {
      id
      title
      ... on DatoCmsAsset {
        gatsbyImageData(
          imgixParams: {crop: "focalpoint", fit: "crop", w: "1600", h: "900"}
        )
      }
    }
  }
`